import React, {Component} from 'react';
import ListOfPuzzles from './ListOfPuzzles';
import SearchBar from './SearchBar';
import LanguageSwitch from './LanguageSwitch/LanguageSwitch'


class LeftMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
        };

        this.getSearchValue = value => {
            this.setState({searchValue: value})
        }
    }

    render() {
        return (
            <div id="leftMenu">
                <div id="wirtualnePuzzleTitle">
                    <img src="/akademia/image/puzzle_logo.svg" alt=""/>
                    <LanguageSwitch/>
                </div>
                <SearchBar getSearchValue={this.getSearchValue} searchValue={this.state.searchValue}/>
                <ListOfPuzzles searchValue={this.state.searchValue}/>
            </div>
        )
    }
}

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/LeftMenu/LeftMenu.js